import { Controller } from "@hotwired/stimulus"

/**
 * Toggles change request fields (risk_assessment, rollback_plan, proposed_schedule)
 * visibility based on the selected ticket_type.
 *
 * data-controller="support--ticket-type-toggle"
 */
export default class extends Controller {
  static targets = ["changeRequestFields"]

  connect() {
    this.toggle()
  }

  toggle() {
    const select = this.element.querySelector(
      '[name="support_ticket[ticket_type]"]',
    )
    if (!select) return

    const isChangeRequest = select.value === "change_request"
    this.changeRequestFieldsTargets.forEach((el) => {
      el.classList.toggle("hidden", !isChangeRequest)
      // Disable hidden required inputs so HTML5 validation does not block submit
      // when the change-request fields are not visible.
      el.querySelectorAll("input, textarea, select").forEach((field) => {
        field.disabled = !isChangeRequest
      })
    })
  }
}
